/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as OfertaRouteImport } from './routes/oferta'
import { Route as OfertaBRouteImport } from './routes/oferta-b'
import { Route as OfertaRetomarRouteImport } from './routes/oferta-retomar'
import { Route as QuizRouteImport } from './routes/quiz'
import { Route as ResultadoRouteImport } from './routes/resultado'
import { Route as VslARouteImport } from './routes/vsl.a'
import { Route as VslBRouteImport } from './routes/vsl.b'
import { Route as VslCRouteImport } from './routes/vsl.c'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const OfertaRoute = OfertaRouteImport.update({
  id: '/oferta',
  path: '/oferta',
  getParentRoute: () => rootRouteImport,
} as any)
const OfertaBRoute = OfertaBRouteImport.update({
  id: '/oferta-b',
  path: '/oferta-b',
  getParentRoute: () => rootRouteImport,
} as any)
const OfertaRetomarRoute = OfertaRetomarRouteImport.update({
  id: '/oferta-retomar',
  path: '/oferta-retomar',
  getParentRoute: () => rootRouteImport,
} as any)
const QuizRoute = QuizRouteImport.update({
  id: '/quiz',
  path: '/quiz',
  getParentRoute: () => rootRouteImport,
} as any)
const ResultadoRoute = ResultadoRouteImport.update({
  id: '/resultado',
  path: '/resultado',
  getParentRoute: () => rootRouteImport,
} as any)
const VslARoute = VslARouteImport.update({
  id: '/vsl/a',
  path: '/vsl/a',
  getParentRoute: () => rootRouteImport,
} as any)
const VslBRoute = VslBRouteImport.update({
  id: '/vsl/b',
  path: '/vsl/b',
  getParentRoute: () => rootRouteImport,
} as any)
const VslCRoute = VslCRouteImport.update({
  id: '/vsl/c',
  path: '/vsl/c',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/oferta': typeof OfertaRoute
  '/oferta-b': typeof OfertaBRoute
  '/oferta-retomar': typeof OfertaRetomarRoute
  '/quiz': typeof QuizRoute
  '/resultado': typeof ResultadoRoute
  '/vsl/a': typeof VslARoute
  '/vsl/b': typeof VslBRoute
  '/vsl/c': typeof VslCRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/oferta': typeof OfertaRoute
  '/oferta-b': typeof OfertaBRoute
  '/oferta-retomar': typeof OfertaRetomarRoute
  '/quiz': typeof QuizRoute
  '/resultado': typeof ResultadoRoute
  '/vsl/a': typeof VslARoute
  '/vsl/b': typeof VslBRoute
  '/vsl/c': typeof VslCRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/oferta': typeof OfertaRoute
  '/oferta-b': typeof OfertaBRoute
  '/oferta-retomar': typeof OfertaRetomarRoute
  '/quiz': typeof QuizRoute
  '/resultado': typeof ResultadoRoute
  '/vsl/a': typeof VslARoute
  '/vsl/b': typeof VslBRoute
  '/vsl/c': typeof VslCRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/oferta'
    | '/oferta-b'
    | '/oferta-retomar'
    | '/quiz'
    | '/resultado'
    | '/vsl/a'
    | '/vsl/b'
    | '/vsl/c'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/oferta'
    | '/oferta-b'
    | '/oferta-retomar'
    | '/quiz'
    | '/resultado'
    | '/vsl/a'
    | '/vsl/b'
    | '/vsl/c'
  id:
    | '__root__'
    | '/'
    | '/oferta'
    | '/oferta-b'
    | '/oferta-retomar'
    | '/quiz'
    | '/resultado'
    | '/vsl/a'
    | '/vsl/b'
    | '/vsl/c'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  OfertaRoute: typeof OfertaRoute
  OfertaBRoute: typeof OfertaBRoute
  OfertaRetomarRoute: typeof OfertaRetomarRoute
  QuizRoute: typeof QuizRoute
  ResultadoRoute: typeof ResultadoRoute
  VslARoute: typeof VslARoute
  VslBRoute: typeof VslBRoute
  VslCRoute: typeof VslCRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/oferta': {
      id: '/oferta'
      path: '/oferta'
      fullPath: '/oferta'
      preLoaderRoute: typeof OfertaRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/oferta-b': {
      id: '/oferta-b'
      path: '/oferta-b'
      fullPath: '/oferta-b'
      preLoaderRoute: typeof OfertaBRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/oferta-retomar': {
      id: '/oferta-retomar'
      path: '/oferta-retomar'
      fullPath: '/oferta-retomar'
      preLoaderRoute: typeof OfertaRetomarRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/quiz': {
      id: '/quiz'
      path: '/quiz'
      fullPath: '/quiz'
      preLoaderRoute: typeof QuizRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/resultado': {
      id: '/resultado'
      path: '/resultado'
      fullPath: '/resultado'
      preLoaderRoute: typeof ResultadoRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/vsl/a': {
      id: '/vsl/a'
      path: '/vsl/a'
      fullPath: '/vsl/a'
      preLoaderRoute: typeof VslARouteImport
      parentRoute: typeof rootRouteImport
    }
    '/vsl/b': {
      id: '/vsl/b'
      path: '/vsl/b'
      fullPath: '/vsl/b'
      preLoaderRoute: typeof VslBRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/vsl/c': {
      id: '/vsl/c'
      path: '/vsl/c'
      fullPath: '/vsl/c'
      preLoaderRoute: typeof VslCRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  OfertaRoute: OfertaRoute,
  OfertaBRoute: OfertaBRoute,
  OfertaRetomarRoute: OfertaRetomarRoute,
  QuizRoute: QuizRoute,
  ResultadoRoute: ResultadoRoute,
  VslARoute: VslARoute,
  VslBRoute: VslBRoute,
  VslCRoute: VslCRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
